// Step 22 — buyer comparison table.
//
// Reads `buyer_portfolio` and `cross_buyer_patterns` from
// `getDealSituationLive`. Every column value is authoritative data
// the backend already gave us — no invented buyer score, no
// synthesized "engagement rate".

import { Link } from "react-router-dom";

import { crossPatternsForBuyer } from "./helpers";
import AIBuyerAttentionChips from "./AIBuyerAttentionChips";

function _fmtWhen(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("sv-SE");
  } catch {
    return String(iso);
  }
}

export default function AIBuyerComparisonTable({
  portfolio,
  patterns,
  workspaceId,
}) {
  return (
    <table className="qai-buyer-compare">
      <thead>
        <tr>
          <th>Köpare</th>
          <th>Intresse</th>
          <th>Skickade</th>
          <th>Svar</th>
          <th>Senaste svar</th>
          <th>Öppna</th>
          <th>Signaler</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {portfolio.map((row) => {
          const acq = row.acquirer;
          const acquirerPatterns = crossPatternsForBuyer(patterns, acq.id);
          const interest = row.interest_signal;
          return (
            <tr key={acq.id} data-buyer-row={acq.id}>
              <td>
                <Link
                  to={`/deals/${workspaceId}/buyers/${acq.id}`}
                  className="qai-deals-link"
                >
                  {acq.name}
                </Link>
                {acq.country && (
                  <span className="qai-buyer-compare-country">
                    {acq.country}
                  </span>
                )}
              </td>
              <td>
                {interest?.value ? (
                  <span className="qai-buyer-compare-interest">
                    <span
                      className="qai-finding-badge"
                      data-tone="origin"
                      title="Backend labels interest_signal as inference (Step 11)."
                    >
                      {interest.fact_or_inference === "fact" ? "Fakta" : "Slutsats"}
                    </span>
                    <span>{interest.value}</span>
                  </span>
                ) : (
                  <span className="qai-buyer-compare-none">—</span>
                )}
              </td>
              <td>{row.communication?.outbound_sent_count ?? 0}</td>
              <td>{row.communication?.inbound_count ?? 0}</td>
              <td>{_fmtWhen(row.communication?.last_inbound_at)}</td>
              <td>{row.open_items_count ?? 0}</td>
              <td>
                <AIBuyerAttentionChips
                  row={row}
                  patternsForBuyer={acquirerPatterns}
                />
              </td>
              <td>
                <Link
                  to={`/deals/${workspaceId}/buyers/${acq.id}`}
                  className="qai-page-section-link"
                >
                  Öppna →
                </Link>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
